import { motion } from 'motion/react';
import styled from 'styled-components';

export const RandomNameStyles = styled(motion.button)`
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.1px;
  padding: 14px;
  border-radius: 12px;
  background: #765279;
  width: 100%;
  display: block;
  max-width: 330px;
  margin: 24px auto 0;
  border: none;
  outline: none;
  transition: all 0.3s ease;

  &:hover {
    background: #ffc9fb;
    color: #171123;
  }
`;
